var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no_data"},[_vm._m(0),_c('div',{staticClass:"mt-3"},[_c('span',[_vm._v(_vm._s(_vm.$t('no_data')))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"no-data-icon"},[_c('img',{attrs:{"height":"28px","src":require("../assets/images/actions/empty.png"),"alt":""}})])
}]

export { render, staticRenderFns }